import { formatDateShort } from "./format";

export function accountingRangeError(from: string, to: string): string | null {
  if (!from || !to) return "Wähle Von und Bis, um den Zeitraum einzugrenzen.";
  for (const value of [from, to]) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return "Wähle ein gültiges Datum.";
    const day = new Date(`${value}T00:00:00Z`);
    if (!Number.isFinite(day.getTime()) || day.toISOString().slice(0, 10) !== value) return "Wähle ein gültiges Datum.";
  }
  return from > to ? "Das Von-Datum darf nicht nach dem Bis-Datum liegen." : null;
}

export function accountingRangeLabel(from: string, to: string): string {
  return `${formatDateShort(from)} bis ${formatDateShort(to)} · Belegdatum`;
}

export function recentAccountingRange(months: number): { from: string; to: string } {
  const today = new Date();
  const end = new Date(Date.UTC(today.getFullYear(), today.getMonth(), today.getDate()));
  const start = new Date(end);
  start.setUTCDate(1);
  start.setUTCMonth(start.getUTCMonth() - months);
  const last = new Date(Date.UTC(start.getUTCFullYear(), start.getUTCMonth() + 1, 0)).getUTCDate();
  start.setUTCDate(Math.min(end.getUTCDate(), last));
  return { from: start.toISOString().slice(0, 10), to: end.toISOString().slice(0, 10) };
}
